// extracted by mini-css-extract-plugin
export var drawerPaper = "_1h-0";
export var itemImage = "_1h-1";